import PropTypes from 'prop-types'

export default function Checkbox({
  id,
  type,
  children,
  onChange,
  active,
  disabled,
  helpText,
  hidden,
  inputProps,
}) {
  const CheckboxComponent =
    !type || type === 'default' ? CustomCheckbox : Toggle

  return (
    <label
      title={helpText}
      className={`tw-flex tw-relative tw-items-center tw-mb-0 tw-text-sm tw-truncate ${
        disabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer'
      }`}
      htmlFor={id}>
      <input
        type="checkbox"
        id={id}
        className="tw-absolute tw-opacity-0 tw-w-0 tw-h-0"
        onChange={onChange}
        checked={!!active}
        disabled={!!disabled}
        {...inputProps}
      />
      <CheckboxComponent active={active} disabled={disabled} hidden={hidden}>
        {children}
      </CheckboxComponent>
    </label>
  )
}

Checkbox.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
  active: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'toggle', 'green']),
  helpText: PropTypes.string,
  hidden: PropTypes.bool,
  inputProps: PropTypes.object,
}

export function CustomCheckbox({ active, disabled, hidden, children }) {
  return (
    <>
      <span
        className={`
      tw-y-auto
      tw-inset-y-0
      tw-w-4
      tw-h-4
      tw-border-2 
      tw-border-solid
      tw-rounded-sm
      tw-duration-100 
      tw-ease-linear
      tw-leading-none
      tw-flex
      tw-items-center
      tw-justify-center
      
      ${hidden ? 'tw-invisible tw-opacity-0' : ''}
      ${
        active
          ? 'tw-border-primary tw-bg-primary'
          : `tw-bg-white ${
              disabled
                ? 'tw-border-system-grey-100'
                : 'tw-border-system-grey-400'
            }`
      }
    `}>
        {active && (
          <svg
            className={`
        tw-transition-all 
        tw-duration-100 
        tw-ease-linear 
        tw-fill-current 
        tw-text-white 
        tw-pointer-events-none`}
            viewBox="0 0 21 21">
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z"></path>
          </svg>
        )}
      </span>
      {children && (
        <span
          className={`tw-ml-2 ${disabled ? 'tw-text-system-grey-400' : ''}`}>
          {children}
        </span>
      )}
    </>
  )
}

CustomCheckbox.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
}

export function Toggle({ active, disabled, children }) {
  return (
    <>
      <div className={'tw-block tw-group tw-relative'}>
        <div
          className={`
        tw-w-10 
        tw-h-4
        tw-rounded-full
        tw-shadow-inner 
        tw-border 
        tw-border-solid 
        tw-transition-all 
        tw-duration-300 
        tw-ease-in-out 
        tw-bg-white
        ${
          active
            ? 'tw-border-primary'
            : `tw-border-system-grey-200 ${
                !disabled ? 'group-hover:tw-border-system-grey-300' : ''
              }`
        }
        `}></div>
        <div
          className={`
        tw-absolute 
        tw-w-4
        tw-h-2
        tw-rounded-full 
        tw-shadow 
        tw-inset-0 
        tw-m-1
        tw-transition-all 
        tw-duration-300 
        tw-ease-in-out 
        ${
          active
            ? 'tw-bg-primary tw-custom-translate-x-full'
            : `tw-bg-system-grey-200 ${
                !disabled ? 'group-hover:tw-bg-system-grey-300' : ''
              }`
        }
        `}></div>
      </div>
      {children && (
        <span
          className={`tw-ml-3 ${disabled ? 'tw-text-system-grey-400' : ''}`}>
          {children}
        </span>
      )}
    </>
  )
}

Toggle.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
}
